import React, { useState, useEffect, lazy } from "react";
import Translator, { __ } from "services/Translator";
import { Link } from "react-router-dom";
// custom component

const CashierModals = lazy(() => import("elements/dashboard_elements/CashierModals"));
const SupportSidebar = lazy(() => import("elements/SupportSidebar"));
const UserDropDownMenu = lazy(() => import("elements/UserDropDownMenu"));

const Header = (props) => {
  const isAuthenticated = props.isAuthenticated;

  return (
    <>
      <header>
        <div className="header_menu_area">
          <div
            onClick={() => {
              props.setLeftSidebarSlide(!props.leftSidebarSlide);
            }}
            className={"overlay " + (props.leftSidebarSlide ? "active" : "")}
          >
            <div className="button"></div>
          </div>
          <div className="logo_area">
            <Link to="/">
              {!props.isMobileDevice && (
                <img
                  alt="genie"
                  className="with_logo"
                  src={require("assets/images/v2/common/genie-logo.svg").default}
                />
              )}
              {props.isMobileDevice && (
                <img
                  className="with_logo"
                  style={{ width: "30px" }}
                  src={require("assets/images/v2/common/genie-footer.svg").default}
                  alt="genie"
                />
              )}
            </Link>
          </div>
          <div className="wallet_area">{isAuthenticated && <CashierModals {...props} />}</div>
          <div className="user_menu_area">
            {isAuthenticated && <UserDropDownMenu {...props} />}
            {!isAuthenticated && (
              <>
                <div className="login_reg_btn_area">
                  <Link
                    hrefLang={Translator.getSelectedLanguage().code}
                    onClick={() => {
                      props.setModalLoginPropsData(true);
                      setTimeout(function () {
                        props.setModalLoginPropsData(false);
                      }, 500);
                    }}
                    className="commonBtn filledBtn"
                  >
                    {__("Log In")}
                  </Link>
                  <Link
                    hrefLang={Translator.getSelectedLanguage().code}
                    onClick={() => {
                      props.setModalSignUpPropsData(true);
                      setTimeout(function () {
                        props.setModalSignUpPropsData(false);
                      }, 500);
                    }}
                    className="registerBtn commonBtn filledBtn yellowBtn"
                  >
                    {__("Register")}
                    <img
                      className="giftIcon heartbeat"
                      alt=""
                      src={require("assets/images/v2/common/easter-egg.webp").default}
                    />
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>
        <SupportSidebar {...props} />
      </header>
    </>
  );
};

export default Header;
